import { render, staticRenderFns } from "./link.vue?vue&type=template&id=21696253&scoped=true&"
var script = {}
import style0 from "./link.vue?vue&type=style&index=0&id=21696253&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21696253",
  null
  
)

component.options.__file = "link.vue"
export default component.exports